import getProductPermissionGates from '@atlassian/jira-common-util-get-tenant-context/src/product-permission-gates';
import getMeta from '@atlassian/jira-get-meta';
import {
	type Application,
	JIRA_CORE,
	JIRA_SERVICE_DESK,
	JIRA_SOFTWARE,
	JIRA_PRODUCT_DISCOVERY,
	type ApplicationEdition,
	FREE_EDITION,
} from '@atlassian/jira-shared-types';
/**
 * Evaluates if permission gating is necessary given the application type and edition.
 * Permission gating is considered for specific application types only when in the free edition.
 */
export const shouldApplyPermissionsGate = (
	application?: Application,
	edition?: ApplicationEdition,
): boolean => {
	const productPermissionGates = getProductPermissionGates(getMeta);
	let permissionGated;
	switch (application) {
		case JIRA_SOFTWARE:
			permissionGated = productPermissionGates.software;
			break;
		case JIRA_PRODUCT_DISCOVERY:
			permissionGated = productPermissionGates.productDiscovery;
			break;
		case JIRA_SERVICE_DESK:
			permissionGated = productPermissionGates.serviceDesk;
			break;
		case JIRA_CORE:
			permissionGated = productPermissionGates.core;
			break;
		default:
			permissionGated = true;
			break;
	}
	return application === undefined || edition === undefined
		? false
		: permissionGated && edition === FREE_EDITION;
};
